import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';


const headerDataSameHash = [
  { id: 'checkbox', label: null, sort: false },
  { id: 'reservationdate', label: 'DATA', sort: true },
  { id: 'expirationdate', label: 'DATA VALIDADE', sort: true },
  { id: 'owner', label: 'TITULAR', sort: true },
  { id: 'customer', label: 'CLIENTE', sort: true },
  { id: 'icon', label: null, sort: false }
];

const headerDataAll = [
  { id: 'checkbox', label: null, sort: false },
  { id: 'announcedoptionals', label: 'OPCIONAIS ANUNCIADOS', sort: true },
  { id: 'color', label: 'COR', sort: true },
  { id: 'saleschannels', label: 'CANAIS VENDA', sort: true },
  { id: 'reservationdate', label: 'DATA', sort: true },
  { id: 'expirationdate', label: 'DATA VALIDADE', sort: true },
  { id: 'owner', label: 'TITULAR', sort: true },
  { id: 'customer', label: 'CLIENTE', sort: true },
  { id: 'icon', label: null, sort: false }
];

const styles = theme => ({
  tblHeadT: {
    color: '#ffffff',
    fontSize: '14px'
  },
  tblBorder: {
    border: '2px solid #ffffff'
  },
  headerHeight: {
    height: '40px'
  },
  textCenter: {
    textAlign: 'center'
  },
  cellPadding: {
    paddingLeft: '16px',
    '&:last-child': {
      paddingLeft: '16px'
    }
  },
  tblSort: {
    height: '12px',
    width: '12px',
    margin: '0px 2px'
  }
});


class RUCarOrderReservationsTableHeader extends React.Component {

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };


  render() {
    const { order, orderBy, classes } = this.props;
    let headerData = this.props.reservationFilterValue === 'sameCharacteristics' ? headerDataSameHash : headerDataAll;

    return (
      <TableRow className={classes.headerHeight} >
      {headerData.map(column => {
        return (
          <TableCell
            key={column.id}
            padding='none'
            sortDirection={orderBy === column.id ? order : false}
            className={column.sort ? classNames(classes.tblHeadT, classes.tblBorder, classes.textCenter, classes.cellPadding) : classes.tblBorder}
          >
            {column.sort ?
              <TableSortLabel
                className={classes.tblHeadT}
                active={orderBy === column.id}
                direction={order}
                onClick={this.createSortHandler(column.id)}
                classes={{ icon: classes.tblSort }}
              >
                {column.label}
              </TableSortLabel>
              : column.label}
          </TableCell>
        );
      }, this)}
    </TableRow>
    );
  }
}

RUCarOrderReservationsTableHeader.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};

export default withStyles(styles)(RUCarOrderReservationsTableHeader);


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsManagement/UsedRentalsCarsList/UsedRentalsCarOrdering/RUCarOrderReservationsTableHeader.js